import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { LanguageLoader } from '../../assets/languages';
import { AddCommas, ReactSelectOptions } from '../utils';
import FieldContainer from './FieldContainer';
import Modal from './Modal';
import Select from "react-select";
import { GetEntryAPI, GetProductsOfBundle, SetPortalPreferencesAPI } from '../../services';
import { SetUserPreferences } from '../../redux/actions/user';
import Table from './Table';
import Stepper, { Step } from './Stepper';

const Lineitem = ({defaultValue, onChange}) =>
{
	const [rowsPerPage, setRowsPerPage] = useState(9);
	const preferences = useSelector((state) => state.preferences);
	const language = LanguageLoader(preferences.language);
	const settings = useSelector((state) => state.settings);	
	const dispatch = useDispatch();
	const [errors, SetErrors] = useState({});
	const [firstLoad, SetFirstLoad] = useState(true);
	const [totalPrice, SetTotalPrice] = useState(0);
	const [totalDiscount, SetTotalDiscount] = useState(0);
	const [totalVat, SetTotalVat] = useState(0);
	const [filter, SetFilter] = useState(Object.keys(settings.lineitem.filters.options)[0] || false);
	const [queryString, SetQueryString] = useState('');
	const [list, SetList] = useState([]);
	const [listBundle, SetListBundle] = useState([]);
	const [selected, SetSelected] = useState([]);
	const [bundleSelected, SetBundleSelected] = useState([]);
	const [items, SetItems] = useState([]);
	const [pagination, ResetPagination] = useState(false);
	const [fallDown, SetFallDown] = useState(false);
	const [popupTrigger, SetPopupTrigger] = useState(false);
	const [step, SetStep] = useState(1);
	const [showItemModal, setShowItemModal] = useState(true);
	const [showBundleModal, setShowBundleModal] = useState(true);
	const [searchFields, SetSearchFields] = useState({
		part_number: preferences.lineitemSearchFields ? preferences.lineitemSearchFields.indexOf('part_number') !== -1 : true,
		brand_name: preferences.lineitemSearchFields ? preferences.lineitemSearchFields.indexOf('brand_name') !== -1 : true,
		name: preferences.lineitemSearchFields ? preferences.lineitemSearchFields.indexOf('name') !== -1 : true
	});

	useEffect(() =>
	{
		if(!firstLoad)
		{
			GetProductsList();
		}
	// eslint-disable-next-line
	}, [searchFields]);

	const SaveSearchFields = async (newFields) =>
	{
		let active = [];
		if (newFields.name) active.push("name");
		if (newFields.part_number) active.push("part_number");
		if (newFields.brand_name) active.push("brand_name");
		
		const APIResponse = await SetPortalPreferencesAPI({lineitemSearchFields: active});
		if(Object.keys(APIResponse).length && APIResponse)
		{
			dispatch(SetUserPreferences(APIResponse));
		}
	}


	const textColumns = ['NAME', 'PRODUCT_NAME', 'PART_NUMBER', 'DESCRIPTION', 'ITEM_DESCRIPTION', 'BUNDLE_NAME'];
	const amountColumns = ['PRODUCT_LIST_PRICE', 'VAT_AMT', 'DISCOUNT_AMOUNT'];
	const fields = settings.lineitem && settings.lineitem.fields ? settings.lineitem.fields : {};
	const columns = fields ? Object.keys(fields).filter((field) => fields[field].list === true) : [];	
	const productUnits = settings.lineitem && settings.lineitem.dropdown && settings.lineitem.dropdown.usage_unit_list ? settings.lineitem.dropdown.usage_unit_list : {};
	const [sortedList, setSortedList] = useState(list);

	let filterOptions = false;
	let filterKey = false;
	/* GENERATE PRODUCT POPUP COLUMNS BASED ON USER ROLE */
	const productPopupColumns = {
		name: language.FIELDS.PRODUCT_NAME,
		part_number: language.FIELDS.PART_NUMBER,
		brand_name: language.FIELDS.BRAND_NAME,
		price: language.FIELDS.UNIT_PRICE,
		selection: ''
	};

	useEffect(() => {
		setSortedList(list);
	}, [list]);

	const handleSort = ({ field, order }) => {
		const sorted = [...sortedList].sort((a, b) => {
			if (a[field] === null) return 1;
			if (b[field] === null) return -1;

			// numeric fields
			if (!isNaN(a[field]) && !isNaN(b[field])) 
			{
				return order === 'ASC'
					? Number(a[field]) - Number(b[field])
					: Number(b[field]) - Number(a[field]);
			}
			// string fields
			return order === 'ASC'
				? String(a[field]).localeCompare(String(b[field]))
				: String(b[field]).localeCompare(String(a[field]));
		});

		setSortedList(sorted);
	};
	
	const bundlePopupColumns = {
		name: language.FIELDS.PRODUCT_NAME,
		selection: ''
	};
	if(!fields.part_number || fields.part_number.access === 'disabled')
	{
		delete productPopupColumns.part_number;
	}
	if(!fields.brand_name || fields.brand_name.access === 'disabled')
	{
		delete productPopupColumns.brand_name;
	}
	if(!fields.product_list_price || fields.product_list_price.access === 'disabled')
	{
		delete productPopupColumns.product_list_price;
	}

	if(settings.lineitem && settings.lineitem.filters)
	{
		if(settings.lineitem.filters.options)
		{
			filterOptions = ReactSelectOptions(settings.lineitem.filters.options);
		}
		if(settings.lineitem.filters.key)
		{
			filterKey = settings.lineitem.filters.key;
		}
	}

	useEffect(() =>
	{
		if(firstLoad)
		{
			if(defaultValue && defaultValue.length)
			{
				SetItems(defaultValue);
				SetSelected(defaultValue);
				SetFirstLoad(false);
			}
			GetProductsList();
			GetBundleList();
		}
	// eslint-disable-next-line
	}, [defaultValue]);

	const ChangeFilterHandler = value =>
	{
		if(filterKey && filterKey !== 'AOS_Product_Categories')
		{
			if(selected.find(existItem => existItem.deleted === 0 || !existItem.deleted))
			{
				if(window.confirm(language.ERROR.DELETE_ALL_LINEITEMS))
				{
					const temp = selected.map(item => true ? { ...item, deleted: 1 } : item);
					SetItems(temp);
					SetSelected(temp);
				}
			}
		}
		SetFilter(value);
		GetProductsList({filter: value});
		GetBundleList();
	}

	const Calculation = () =>
	{
		let total = 0;
		let totalDiscountAmount = 0;
		let totalVatAmount = 0;
		for (const item of selected)
		{
			if(!item.deleted && item.product_list_price && item.product_qty)
			{
				let grandTotal = item.product_list_price * item.product_qty;
				if(item.vat_amt)
				{
					grandTotal = parseFloat(grandTotal) + parseFloat(item.vat_amt);
				}
				if(item.discount_amount)
				{
					grandTotal = parseFloat(grandTotal) - parseFloat(item.discount_amount);
				}
				totalDiscountAmount += parseFloat(item.discount_amount);
				totalVatAmount += parseFloat(item.vat_amt);
				total += grandTotal;
			}
		}
		SetTotalPrice(AddCommas(total));
		SetTotalDiscount(AddCommas(totalDiscountAmount));
		SetTotalVat(AddCommas(totalVatAmount));
	}

	useEffect(() =>
	{
		Calculation();
		if(onChange)
		{
			onChange(items);
		}
	// eslint-disable-next-line
	}, [items]);

	useEffect(() => {
		const calculateRows = () => {
			const screenHeight = window.innerHeight;
			const screenWidth = window.innerWidth;
			const rowHeight = 55;
			const modalHeight = screenHeight * 0.9;
			const fixedElementsHeight = 50 + 70 + 50 + 30 + 40;
			const availableHeight = modalHeight - fixedElementsHeight;
			let calculated = Math.floor(availableHeight / rowHeight);
			if (screenWidth >= 1920) {
				calculated = Math.max(calculated, 15);
			} else if (screenWidth >= 1440) {
				calculated = Math.max(calculated, 12);
			} else if (screenWidth >= 1024) {
				calculated = Math.max(calculated, 10);
			} else if (screenWidth >= 768) {
				calculated = Math.max(calculated, 8);
			} else {
				calculated = 5;
			}
			calculated = Math.max(6, Math.min(calculated, 20));
			setRowsPerPage(calculated);
		};
		calculateRows();
		window.addEventListener('resize', calculateRows);
		return () => window.removeEventListener('resize', calculateRows);
	}, []);

	const GetProductsList = (params={}) =>
	{
		try
		{
			let filterValue = params.filter;
			let searchQuery = params.query;
			
			if(typeof filterValue !== 'string' || !filterValue)
			{
				filterValue = filter; 
			}
			if(typeof searchQuery !== 'string')
			{
				searchQuery = queryString; 
			}
			const APIData = {
				module: 'AOS_Products',
				selected_fields: ['id', 'name', 'part_number', 'brand_name', 'price', 'main_usage_unit', 'secondary_usage_unit', 'units_ratio'],
				filter: false,
				order_by: 'name ASC'
			};
			if(filterValue && filterValue.length && filterKey)
			{
				APIData.filter = {key: filterKey, value: filterValue};
			}
			
			if(searchQuery.length)
			{
				let queries = [];
				const words = (searchQuery.indexOf(' ') !== -1) ? searchQuery.split(' ') : [searchQuery];
				if(words.length)
				{
					for(const word of words)
					{
						let fieldQueries = [];
						if(searchFields.part_number) 
						{
							fieldQueries.push('aos_products.part_number LIKE "%'+word+'%"');
							fieldQueries.push('aos_products.properties_as LIKE "%'+word+'%"');
						}
						if(searchFields.brand_name) fieldQueries.push('aos_products.brand_name LIKE "%'+word+'%"');
						if(searchFields.name) fieldQueries.push('aos_products.name LIKE "%'+word+'%"');
						if(!fieldQueries.length)
						{
							fieldQueries.push('aos_products.part_number LIKE "%'+word+'%"');
							fieldQueries.push('aos_products.brand_name LIKE "%'+word+'%"');
							fieldQueries.push('aos_products.name LIKE "%'+word+'%"');
							fieldQueries.push('aos_products.properties_as LIKE "%'+word+'%"');
						}
						queries.push('('+fieldQueries.join(' OR ')+')');
					}
				}
				APIData.query = queries.length ? '('+queries.join(' AND ')+')' : '';
			}
			GetEntryAPI(APIData).then(APIResponse =>
			{
				SetList(APIResponse || []);
			});
		}
		catch (ex){}
	}

	const GetBundleList = (params={}) =>
	{
		try
		{
			let filterValue = params.filter;
			let searchQuery = params.query;
			
			if(typeof filterValue !== 'string' || !filterValue)
			{
				filterValue = filter; 
			}
			if(typeof searchQuery !== 'string')
			{
				searchQuery = queryString; 
			}
			const APIData = {
				module: 'Product_Bundle',
				selected_fields: ['id', 'name', 'status'],
				filter: false,
				order_by: 'name ASC'
			};
			if(filterValue && filterValue.length && filterKey)
			{
				APIData.filter = {key: filterKey, value: filterValue};
			}
			
			if(searchQuery.length)
			{
				let queries = [];
				const words = (searchQuery.indexOf(' ') !== -1) ? searchQuery.split(' ') : [searchQuery];
				if(words.length)
				{
					for(const word of words)
					{
						queries.push('(product_bundle.name LIKE "%'+word+'%")');
					}
				}
				APIData.query = queries.length ? '('+queries.join(' AND ')+')' : '';
			}
			if(settings.lineitem.show_bundles == 1)
			{
				GetEntryAPI(APIData).then(APIResponse =>
				{
					SetListBundle(APIResponse || []);
				});
			}
		}
		catch (ex){}
	}

	const AddToProducts = (product) =>
	{
		const exists = selected.filter(existItem => existItem.product_id === product.id);
		if(!exists.length || exists[0].deleted === 1)
		{
			const dataArray = {
				id: '',
				name: product.name,
				product_id: product.id,
				product_list_price: product.price,
				part_number: product.part_number,
				units_ratio: product.units_ratio,
				main_unit_type: product.main_usage_unit,
				secondary_unit_type: product.secondary_usage_unit,
				product_qty: 1,
				product_second_qty: null,
				item_description: '',
				deleted: 0
			};
			SetSelected(selected => [...selected, dataArray]);
		}
	}

	const AddToBundle = (bundle) =>
	{
		const exists = bundleSelected.filter(existItem => existItem.id === bundle.id);
		if(!exists.length || exists[0].deleted === 1)
		{
			const dataArray = {
				id: bundle.id,
				name: bundle.name,
				qty: 0,
				deleted: 0
			
			};
			SetBundleSelected(bundleSelected => [...bundleSelected, dataArray]);
		}
	}

	const ModifyProducts = (key, data) =>
	{
		const temp = [...selected].filter(product => !product.deleted || product.deleted === 0);
		temp[key] = Object.assign(temp[key], data);
		if (temp[key].units_ratio !== '' && temp[key].units_ratio)
		{
			if ('product_qty' in data)
			{
				const qty = parseFloat(String(data.product_qty).replaceAll(',', ''));
				temp[key]['product_second_qty'] = !isNaN(qty) ? qty / temp[key].units_ratio : temp[key]['product_second_qty'];
			}
			else if ('product_second_qty' in data)
			{
				const secondQty = parseFloat(String(data.product_second_qty).replaceAll(',', ''));
				temp[key]['product_qty'] = !isNaN(secondQty) ? secondQty * temp[key].units_ratio : temp[key]['product_qty'];
			}
		}
		SetSelected(temp);
	}

	const ModifyBundle = (key, data) =>
	{
		const temp = [...bundleSelected].filter(product => !product.deleted || product.deleted === 0);
		temp[key] = Object.assign(temp[key], data);
		SetBundleSelected(temp);		
	}

	const RemoveFromProducts = (data) =>
	{
		if(data.id && data.id.length)
		{
			SetSelected(prevData => prevData.map(existItem => existItem.id === data.id ? { ...existItem, deleted: 1 } : existItem));
		}
		else if(data.product_id && data.product_id.length)
		{
			SetSelected(prevData => prevData.map(existItem => existItem.product_id === data.product_id ? { ...existItem, deleted: 1 } : existItem));
		}
	}

	const RemoveFromBundle = (data) =>
	{	
		if(data.id && data.id.length)
		{
			SetBundleSelected(prevData => prevData.map(existItem => existItem.id === data.id ? { ...existItem, deleted: 1 } : existItem));
		}
	
	}

	const RemoveFromItems = (data) =>
	{
		if(data.id && data.id.length)
		{
			SetItems(prevData => prevData.map(item => item.id === data.id ? { ...item, deleted: 1 } : item));
			RemoveFromProducts({id: data.id});
		}
		else if (data.product_id && data.product_id.length)
		{
			SetItems(prevData => prevData.map(item => item.product_id === data.product_id ? { ...item, deleted: 1 } : item));
			RemoveFromProducts({product_id: data.product_id});
		}
	}

	const SubmitItems = () =>
	{
		const temp = [...selected];
		const validation = {};
		for (const key in temp)
		{
			let qty = temp[key].product_qty;
			if(typeof temp[key].product_qty === 'string')
			{
				qty = parseFloat(temp[key].product_qty.replaceAll(',', ''));
			}
			if(isNaN(qty) || qty === 0 || qty === '')
			{
				if(!validation['product_qty'])
				{
					validation['product_qty'] = [];
				}
				validation['product_qty'].push(parseInt(key));
			}
		}
		if(Object.keys(validation).length)
		{
			SetErrors(validation);
		}
		else
		{
			Calculation();
			SetFallDown(true);
			SetItems(selected);
			SetErrors({});
			setShowBundleModal(false);
		}
	};

	const SubmitBundleItems = () =>
	{
		const temp = [...bundleSelected];
		const validation = {};
		for (const key in temp)
		{
			let qty = temp[key].qty;
			if(typeof temp[key].qty === 'string')
			{
				qty = parseFloat(temp[key].qty.replaceAll(',', ''));
			}
			if(isNaN(qty) || qty === 0 || qty === '')
			{
				if(!validation['qty'])
				{
					validation['qty'] = [];
				}
				validation['qty'].push(parseInt(key));
			}
		}
		if(Object.keys(validation).length)
		{
			SetErrors(validation);
		}
		else
		{
			const ids = bundleSelected
			  .filter(item => item.deleted === 0)
			  .map(item => `'${item.id}'`)
			  .join(', ');
			const APIData = {
				product_bundle_id : ids
			};	
			GetProductsOfBundle(APIData).then(APIResponse =>
			{			
				const bundleQtyMap = Object.fromEntries(
				  bundleSelected.map(bundle => [bundle.id, parseInt(bundle.qty)])
				);
				const updatedProducts = APIResponse.filter(p => bundleQtyMap[p.bundle_id] !== undefined).map(p => ({...p,product_qty: parseInt(p.product_qty) * bundleQtyMap[p.bundle_id]}));
				Calculation();
				SetSelected(updatedProducts);
				SetFallDown(true);
				SetItems(updatedProducts);
				columns.push("bundle_name");
				fields["bundle_name"] = {
				  access: "",
				  list: true
				};
				SetErrors({});
				setShowItemModal(false);
			});

		}
	};

	const HandleEditButton = () =>
	{
		/* DISPLAY THE SECOND PAGE OF POPUP */
		SetStep(2);
		SetPopupTrigger(true);
	}
	
	const ClosingPopup = async () =>
	{
		SetFallDown(false);
		SetStep(1);
		SetPopupTrigger(false);
		SetQueryString('');
		GetProductsList({query: ''});
	}
	
	return <div className='w-full'>
		<div className='flex flex-wrap items-end'>
		{filterKey && filterOptions && filterOptions.length ?
			<FieldContainer label={'فیلتر محصولات'} className={'mb-0 ps-0'}>
				<Select
				value={filterOptions.find((option) => option.value === filter)}
				onChange={(selectedOption) => ChangeFilterHandler(selectedOption.value)}
				placeholder={language.COMPONENTS.SELECT_OPTION_PLACEHOLDER}
				options={filterOptions}
				defaultValue={filterOptions[0]}
				isClearable={false}
				menuPlacement="auto"
				className={settings.strings.dropdown_container}
				classNamePrefix={settings.strings.dropdown_prefix}/>
			</FieldContainer>
		: null}
		{showItemModal ?
		<Modal showButtons={false} onClose={ClosingPopup} fallDown={fallDown} trigger={popupTrigger} size={{width: '80vw', height: '90vh'}} handler={<button className='btn mx-1 py-3 px-2 flex items-center' onClick={null}><i className="fa fa-plus me-2"></i><span>{language.COMPONENTS.ADD_PRODUCT}</span></button>}>
			<Stepper onFinish={SubmitItems} step={step}>
				<Step title="مرحله اول" onSubmit={() => ResetPagination(true)}>
					<div className='flex flex-wrap items-end justify-center'>
						<div className='w-full md:w-1/2 flex items-end justify-center'>
							<FieldContainer className="grow">
								{(() => {
									let active = [];
									if (searchFields.brand_name) active.push(language.FIELDS.BRAND_NAME);
									if (searchFields.part_number) active.push(language.FIELDS.PART_NUMBER);
									if (searchFields.name) active.push(language.FIELDS.PRODUCT_NAME);
									const placeholder = active.length ? `${language.FILTER.SEARCH} (${active.join(' - ')})` : language.FILTER.SEARCH;
									return <input type="text" placeholder={placeholder} value={queryString || ''} onChange={e => SetQueryString(e.target.value)} onKeyUp={(e) => e.code === 'Enter' || e.code === 'NumpadEnter' ? GetProductsList() : null}/>
								})()}
							</FieldContainer>
							<div className='mb-5'>
								<button className='btn py-3 px-4 m-0' onClick={GetProductsList}><i className='fa fa-search'></i></button>
							</div>
						</div>
						<div className='w-full md:w-1/2 flex justify-center'>
							<FieldContainer label={language.SEARCH_IN}>
								<div className='flex gap-4 items-center h-full pb-2'>
									<label className='flex items-center gap-2 cursor-pointer'><input type='checkbox' checked={searchFields.name} onChange={() => { const newValue = {...searchFields, name: !searchFields.name}; SetSearchFields(newValue); SaveSearchFields(newValue); }}/><span>{language.FIELDS.PRODUCT_NAME}</span></label>
									<label className='flex items-center gap-2 cursor-pointer'><input type='checkbox' checked={searchFields.part_number} onChange={() => { const newValue = {...searchFields, part_number: !searchFields.part_number}; SetSearchFields(newValue); SaveSearchFields(newValue); }}/><span>{language.FIELDS.PART_NUMBER}</span></label>
									<label className='flex items-center gap-2 cursor-pointer'><input type='checkbox' checked={searchFields.brand_name} onChange={() => { const newValue = {...searchFields, brand_name: !searchFields.brand_name}; SetSearchFields(newValue); SaveSearchFields(newValue); }}/><span>{language.FIELDS.BRAND_NAME}</span></label>
								</div>
							</FieldContainer>
						</div>
					</div>
					<Table reset={pagination} itemsPerPage={rowsPerPage} header={productPopupColumns} SortCallback={handleSort}>
						{sortedList.map((product, index) =>
						{
							const checked = selected.filter(existItem => existItem.product_id === product.id && (!existItem.deleted || existItem.deleted === 0)).length ? true : false;
							return <tr key={index}>
								<td className='cursor-pointer' onClick={() => { selected.filter(existItem => existItem.product_id === product.id && (!existItem.deleted || existItem.deleted === 0)).length ? RemoveFromProducts({product_id: product.id}) : AddToProducts(product) }} dangerouslySetInnerHTML={{ __html: product.name }}></td>
								{fields.part_number && fields.part_number.access !== 'disabled' ? <td>{product.part_number}</td> : null}
								{fields.brand_name && fields.brand_name.access !== 'disabled' ? <td>{product.brand_name}</td> : null}
								{fields.product_list_price && fields.product_list_price.access !== 'disabled' ? <td>{AddCommas(product.product_list_price || product.price)}</td> : null}
								<td><input type='checkbox' className='border-secondary' checked={checked} onChange={(e) => e.target.checked ? AddToProducts(product) : RemoveFromProducts({product_id: product.id})}/></td>
							</tr>
						})}
					</Table>
				</Step>
				<Step className="flex flex-wrap">
					{selected.filter(product => !product.deleted || product.deleted === 0).map((product, index) =>
					{
						const MainUnit = productUnits[product.main_unit_type] ? productUnits[product.main_unit_type] : product.main_unit_type;
						const secondaryUnit = productUnits[product.secondary_unit_type] ? productUnits[product.secondary_unit_type] : product.secondary_unit_type;
						return <div key={index} className="w-full p-1">
							<div className="flex flex-wrap border border-primaryBorder p-3 rounded">
								<div className='w-full flex justify-between'>
									<div className='flex items-center'>
									<span className='inline-block rounded-full bg-primary w-7 h-7 text-center text-white me-3 p-1 text-sm font-bold'>{index+1}</span>
									<span className='font-bold' dangerouslySetInnerHTML={{ __html: product.name }}></span>
									</div>
									<i className='fa fa-trash-alt text-base cursor-pointer hover:text-danger me-2 mt-1' onClick={() => RemoveFromProducts({product_id: product.product_id})}></i>
								</div>
								<div className='flex flex-wrap w-full mt-6'>
									{fields.product_qty && fields.product_qty.access !== 'disabled' ?
									<FieldContainer className={'w-full md:w-1/4'} error={errors.product_qty && errors.product_qty.indexOf(index) !== -1 ? [language.ERROR.IS_REQUIRED] : null} label={<span>{language.FIELDS.QTY}{MainUnit ? <span className='text-xs text-black/50 ms-1'>({MainUnit})</span> : null}</span>}>
										<div className='flex'>
											<button onClick={() => ModifyProducts(index, { product_qty: Number(product.product_qty) - 1 })} className="px-3 py-1 btn btn-secondary rounded-lg font-bold"> - </button>
											<input type="text" value={AddCommas(product.product_qty) || ''} onChange={(e) => ModifyProducts(index, {product_qty: e.target.value})}/>
									  		<button onClick={() => ModifyProducts(index, { product_qty: Number(product.product_qty) + 1 })} className="px-3 py-1 btn btn-secondary rounded-lg"> + </button>
										</div>
									</FieldContainer> : null}
									{fields.product_second_qty && fields.product_second_qty.access !== 'disabled' ?
									<FieldContainer className={'w-full md:w-1/4'} label={<span>{language.FIELDS.PRODUCT_SECOND_QTY}{secondaryUnit ? <span className='text-xs text-black/50 ms-1'>({secondaryUnit})</span> : null}</span>}>
										 <input type="text" value={AddCommas(product.product_second_qty) || ''} onChange={(e) => ModifyProducts(index, {product_second_qty: e.target.value})}/>
									</FieldContainer> : null}
									{fields.item_description && fields.item_description.access !== 'disabled' ?
									<FieldContainer className="grow" label={language.FIELDS.DESCRIPTION}>
										 <textarea rows={1} className="!transition-none !delay-0" value={product.item_description || ''} onChange={(e) => ModifyProducts(index, {item_description: e.target.value})}></textarea>
									</FieldContainer> : null}
								</div>
								{/* <div className='flex flex-wrap w-full'>
									{fields.product_qty && fields.product_qty.access !== 'disabled' ?
									<FieldContainer className={'w-1/2 md:w-1/4'} error={errors.product_qty && errors.product_qty.indexOf(index) !== -1 ? [language.ERROR.IS_REQUIRED] : null} label={<span>{language.FIELDS.QTY}{MainUnit ? <span className='text-xs text-black/50 ms-1'>({MainUnit})</span> : null}</span>}>
										 <input type="text" value={AddCommas(product.product_qty) || ''} onChange={(e) => ModifyProducts(index, {product_qty: e.target.value})}/>
									</FieldContainer> : null}
									{fields.product_qty && fields.product_qty.access !== 'disabled' ?
									<FieldContainer className={'w-1/2 md:w-1/4'} error={errors.product_qty && errors.product_qty.indexOf(index) !== -1 ? [language.ERROR.IS_REQUIRED] : null} label={<span>{language.FIELDS.QTY}{MainUnit ? <span className='text-xs text-black/50 ms-1'>({MainUnit})</span> : null}</span>}>
										 <input type="text" value={AddCommas(product.product_qty) || ''} onChange={(e) => ModifyProducts(index, {product_qty: e.target.value})}/>
									</FieldContainer> : null}
									{fields.product_qty && fields.product_qty.access !== 'disabled' ?
									<FieldContainer className={'w-1/2 md:w-1/4'} error={errors.product_qty && errors.product_qty.indexOf(index) !== -1 ? [language.ERROR.IS_REQUIRED] : null} label={<span>{language.FIELDS.QTY}{MainUnit ? <span className='text-xs text-black/50 ms-1'>({MainUnit})</span> : null}</span>}>
										 <input type="text" value={AddCommas(product.product_qty) || ''} onChange={(e) => ModifyProducts(index, {product_qty: e.target.value})}/>
									</FieldContainer> : null}
									{fields.product_qty && fields.product_qty.access !== 'disabled' ?
									<FieldContainer className={'w-1/2 md:w-1/4'} error={errors.product_qty && errors.product_qty.indexOf(index) !== -1 ? [language.ERROR.IS_REQUIRED] : null} label={<span>{language.FIELDS.QTY}{MainUnit ? <span className='text-xs text-black/50 ms-1'>({MainUnit})</span> : null}</span>}>
										 <input type="text" value={AddCommas(product.product_qty) || ''} onChange={(e) => ModifyProducts(index, {product_qty: e.target.value})}/>
									</FieldContainer> : null}
								</div> */}
							</div>
						</div>
					})}
				</Step>
			</Stepper>
		</Modal>
		: null}
		{showBundleModal && settings.lineitem.show_bundles == 1 ?
			<Modal showButtons={false} onClose={ClosingPopup} fallDown={fallDown} trigger={popupTrigger} size={{width: '80vw', height: '90vh'}} handler={<button className='btn mx-1 py-3 px-2 flex items-center' onClick={null}><i className="fa fa-plus me-2"></i><span>{language.COMPONENTS.ADD_BUNDLE}</span></button>}>
				<Stepper onFinish={SubmitBundleItems} step={step}>
					<Step title="مرحله اول" onSubmit={() => ResetPagination(true)}>
						<div className='flex flex-wrap'>
							<FieldContainer>
								<input type="text" placeholder='جستجو' value={queryString || ''} onChange={e => SetQueryString(e.target.value)} onKeyUp={(e) => e.code === 'Enter' || e.code === 'NumpadEnter' ? GetBundleList() : null}/>
							</FieldContainer>
							<FieldContainer>
								<button className='btn py-3 px-4 m-0' onClick={GetBundleList}><i className='fa fa-search'></i></button>
							</FieldContainer>
						</div>
						<Table reset={pagination} itemsPerPage={rowsPerPage} header={bundlePopupColumns}>
							{listBundle.map((bundle, index) =>
							{
								const checkedBundle = bundleSelected.filter(existItemBundle => existItemBundle.id === bundle.id && (!existItemBundle.deleted || existItemBundle.deleted === 0)).length ? true : false;							
								return <tr key={index}>
									<td className='cursor-pointer' onClick={() => { bundleSelected.filter(existItemBundle => existItemBundle.id === bundle.id && (!existItemBundle.deleted || existItemBundle.deleted === 0)).length ? RemoveFromBundle({id: bundle.id}) : AddToBundle(bundle) }} dangerouslySetInnerHTML={{ __html: bundle.name }}></td>
									<td><input type='checkbox' className='border-secondary' checked={checkedBundle} onChange={(e) => e.target.checked ? AddToBundle(bundle) : RemoveFromBundle({id: bundle.id})}/></td>
								</tr>
							})}
						</Table>
					</Step>
					<Step className="flex flex-wrap">
						{bundleSelected.filter(bundle => !bundle.deleted || bundle.deleted === 0).map((bundle, index) =>
						{
							return <div key={index} className="w-full p-1">
								<div className="flex flex-wrap border border-primaryBorder p-3 rounded">
									<div className='w-full flex justify-between'>
										<div className='flex items-center'>
										<span className='inline-block rounded-full bg-primary w-7 h-7 text-center text-white me-3 p-1 text-sm font-bold'>{index+1}</span>
										<span className='font-bold' dangerouslySetInnerHTML={{ __html: bundle.name }}></span>
										</div>
										<i className='fa fa-trash-alt text-base cursor-pointer hover:text-danger me-2 mt-1' onClick={() => RemoveFromBundle({id: bundle.id})}></i>
									</div>
									<div className='flex flex-wrap w-full mt-6'>
										<FieldContainer className={'w-full md:w-1/4'} label={<span>{language.FIELDS.QTY}</span>}>
											 <input type="text" value={AddCommas(bundle.qty) || ''} onChange={(e) => ModifyBundle(index, {qty: e.target.value})}/>
										</FieldContainer>
									</div>
								</div>
							</div>
						})}
					</Step>
				</Stepper>
			</Modal>
		 :null}
		</div>
		<div className='grow flex gap-10 text-sm mt-3'>
			<table>
				<thead>
				<tr>
					{columns.map((item, index) => <th key={index}>{language.FIELDS[item.toUpperCase()]}</th>)}
					<th className='w-1'></th>
				</tr>
				</thead>
				<tbody>
				{items.filter(item => !item.deleted || item.deleted === 0).length ? items.filter(item => !item.deleted || item.deleted === 0).map((item, index) =>
				{
					return <tr key={index}>
						{columns.map(field =>
						{
							let value = AddCommas(item[field]);
							if(textColumns.includes(field.toUpperCase()))
							{
								value = item[field];
							}
							else if(item.currency_symbol && amountColumns.includes(field.toUpperCase()))
							{
								value += ' '+item.currency_symbol;
							}
							if(field.toUpperCase() === "NAME")
							{
								return <td key={field} dangerouslySetInnerHTML={{ __html: value }}></td>
							}
							return <td key={field}>{value}</td>
						})}
						<td>
							<div className='flex gap-3'>
								<i className="px-1 fa fa-pencil cursor-pointer hover:text-primary" onClick={HandleEditButton}></i>
								<i className='px-1 fa fa-trash-alt cursor-pointer hover:text-danger' onClick={() => { RemoveFromItems({product_id: item.product_id});} }></i>
							</div>
						</td>
					</tr>
				}) : <tr><td colSpan={columns.length + 1}>{language.NO_DATA}</td></tr>}
				</tbody>
			</table>
		</div>
		<div className='flex'>
			<FieldContainer label={language.FIELDS.DISCOUNT} className='mt-3 mb-0'>
				<div className='value'>{totalDiscount}{(items && items[0] && items[0].currency_symbol ? ' '+items[0].currency_symbol : null)}</div>
			</FieldContainer>
			<FieldContainer label={language.FIELDS.TAX} className='mt-3 mb-0'>
				<div className='value'>{totalVat}{(items && items[0] && items[0].currency_symbol ? ' '+items[0].currency_symbol : null)}</div>
			</FieldContainer>
		</div>
		<div className='flex'>
			<FieldContainer label={language.FIELDS.GRAND_TOTAL} className='mt-3 mb-0'>
				<div className='value'>{totalPrice}{(items && items[0] && items[0].currency_symbol ? ' '+items[0].currency_symbol : null)}</div>
			</FieldContainer>
			<FieldContainer label={language.FIELDS.TOTAL_QTY} className='mt-3 mb-0'>
				<div className='value'>{AddCommas(items.filter(item => !item.deleted || item.deleted === 0).reduce((sum, item) => Number(sum) + Number(item.product_qty), 0))}</div>
			</FieldContainer>
		</div>
	</div>
};

export default Lineitem;